import { render, staticRenderFns } from "./Tooltip.component.vue?vue&type=template&id=0a527a19&scoped=true&"
import script from "./Tooltip.component.vue?vue&type=script&lang=js&"
export * from "./Tooltip.component.vue?vue&type=script&lang=js&"
import style0 from "./Tooltip.component.vue?vue&type=style&index=0&id=0a527a19&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a527a19",
  null
  
)

export default component.exports